export const checkIsSafeRedirect = (path: string) => path.startsWith("/");

export const checkIsValidEnum = (value: number, max: number) => {
  if (Number.isInteger(value)) {
    return 0 <= value && value <= max;
  } else {
    return false;
  }
};
